<template>
    <AltNavigationBar/>
<div class="container-account">
      <div class="content m-3" >
         

        <div class="col">
<img class="logo" src="../assets/tangerine-logo.svg" alt="...">

            <div class="form-container row">
            <div class="col-12 my-3 start-col">
             
                <LoginForm @submit="handleSubmit" :isLogin="true"/>
            </div>
            
            </div>
            </div>
        
        </div>
    </div>
    <AltFooterView/>
</template>

<script>
import AltNavigationBar from '@/components/AltNavigationBar.vue';
import AltFooterView from '@/components/AltFooter.vue';
import LoginForm from '@/components/LoginForm.vue';
import { auth } from '../../src/firebase.js';
import { signInWithEmailAndPassword } from 'firebase/auth';

export default{
    name: "LoginScreen",
components: {
    AltNavigationBar,
    LoginForm,
    AltFooterView
  },
  methods:{
    handleSubmit(email,password,firstName,lastName){
        console.log(`${email} ${password} ${firstName} ${lastName}`)
        signInWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    console.log('User signed up:', userCredential.user);
  })
  .catch((error) => {
    console.error(error);
  });
    }
  }
}
</script>

<style>

</style>